export default __webpack_public_path__ + "static/media/cleaning-booth.010a8569.jpeg";